import { gray40opacity10 } from '../../../colors/gray';
export var MuiCircularProgress = {
    defaultProps: { size: 32, thickness: 4 },
    styleOverrides: {},
    customOverrides: {
        root: {
            position: 'relative',
        },
        bottom: {
            color: gray40opacity10,
        },
        top: {
            position: 'absolute',
            left: 0,
        },
    },
};
